<template>
  <div id="slider" class="corp-carousel">
    <transition-group tag="div"
      :name="transitionName"
      class="slides-group"
    >
      <div v-if="show"
        :key="current"
        class="slide"
        :class="slides[current].className"
      >
        <div class="slide-content">
          <p class="slide-review">{{ slides[current].review }}</p>
          <p>{{ slides[current].author }}</p>
        </div>
      </div>
    </transition-group>
    <!-- Previous button -->
    <div class="btn btn-prev"
      aria-label="Previous slide"
      @click="slide(-1)"
    >
      &#10094;
    </div>
    <!-- Next button -->
    <div class="btn btn-next"
      aria-label="Next slide"
      @click="slide(1)"
    >
      &#10095;
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      current: 0,
      direction: 1,
      transitionName: 'fade',
      show: false,
      slides: [
        { author: 'Mr G Andrew', review: '"First class service. A real pleasure to deal with a business who are so professional and efficient."' },
        { author: 'Mr J Lowe', review: '"I always book my travel – business and personal – through Trailfinders. I’ve rated the service as excellent as I can’t think how it could be better"' },
        { author: 'Miss B Laleh', review: '"Best customer service one could possibly ask for. Superb information, knowledgeable, warm, friendly and super professional"' },
        { author: 'Mr J Frotzler', review: '"Always a pleasure to deal with Trailfinders. I have dealt with them for many years for personal and business travel . They provide a very fast, efficient, reliable and friendly service."' },
        { author: 'Mr P Craigr', review: '"As ever - Trailfinders the best in the UK for business travel!"' },
        { author: 'Mr A Duffield', review: '"Top quality service as always - professional, efficient and friendly. Makes all my business travel needs a breeze. Thank you!"' },
        { author: 'Mr J Clifford', review: '"Excellent for complex business travel . Knowledgeable and helpful staff who are patient and make great suggestions."' }
      ]
    }
  },
  mounted () {
    this.show = true
    this.slides = this.shuffle(this.slides)
  },
  methods: {
    slide (dir) {
      this.direction = dir
      dir === 1 ? (this.transitionName = 'slide-next') : (this.transitionName = 'slide-prev')
      const len = this.slides.length
      this.current = (this.current + dir % len + len) % len
    },
    shuffle (sourceArray) {
      // Create storage vars
      let tempIndex
      let currentIndex
      let randomIndex
      
      for (let i = sourceArray.length -1; i >= 0; i--) {
        // Get random index
        randomIndex = Math.floor(Math.random() * sourceArray.length)
        // Save item at current index to temp var
        tempIndex = sourceArray[i]
        // save item at random index to current index
        currentIndex = sourceArray[randomIndex]
        // swap current index with temp index
        sourceArray[i] = currentIndex
        sourceArray[randomIndex] = tempIndex
      }
      return sourceArray
    }
  }
}
</script>

<style scoped>
/* FADE IN */
.fade-enter-active {
  transition: opacity 1s;
}

.fade-enter {
  opacity: 0;
}

/* GO TO THE NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
  transition: transform 0.5s ease-in-out;
}

.slide-next-enter {
  transform: translate(100%);
}

.slide-next-leave-to {
  transform: translate(-100%);
}

/* GO TO THE PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: transform 0.5s ease-in-out;
}

.slide-prev-enter {
  transform: translate(-100%)
}

.slide-prev-leave-to {
  transform: translate(100%)
}

/* SLIDES CLASSES */
.blue {
  background-color: #4a69bd;
}

.red {
  background-color: #e55039;
}

.yellow {
  background-color: #f6b93b;
}

/* SLIDER STYLES */
body {
  overflow: hidden;
  margin: 0;
  font-size: 50px;
  font-family:Arial, Helvetica, sans-serif;
  color: #fff;
}

#slider {
  width: 100%;
  position: relative;
}

.slide {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.slide-content {
  width: 50%;
  text-align: center;
}

.slide-review {
  font-weight: bold;
}

.btn {
  z-index: 10;
  cursor: pointer;
  border: 3px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  position: absolute;
  left: 1%;
  transition: transform 0.3s ease-in-out;
  user-select: none;
  font-size: 30px;
}

.btn-next {
  left: auto;
  right: 1%;
}

.btn:hover {
  transform: scale(1.1)
}
</style>